// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Anchor-module--cls1--3nYtJ","cls2":"Anchor-module--cls2--vVAAP Anchor-module--cls1--3nYtJ"};